// This file is intended for global constants that are shared across
// the application. Use this file sparingly. For constants with a single
// usage, it can be better to include them in the module scope of the
// file they're used in.
export const MY_CARS_KEY = 'mycars-user';
export const TOPIC_KEY = 'mycars-user-update';

export const options = {
	RECENTLY_VIEWED: 'viewed',
	SAVED: 'saved',
	TRACKED_PRICE: 'tracked'
};

export const SMALL_SCREEN_SIZE = 992;
export const MOBILE_SCREEN_SIZE = 768;

export const emptyInventoryObj = {
	pageInfo: {
		totalCount: 0,
		pageSize: 0,
		pageStart: 0,
		trackingData: []
	},
	inventory: [],
	incentives: {},
	accounts: {}
};

export const complementaryInventoryObj = {
	pageInfo: {
		totalCount: 30,
		pageSize: 31,
		pageStart: 0,
		enableMyCars: true,
		enableMyCarsOnVLP: true,
		enableMediaCarousel: true,
		trackingData: []
	},
	incentives: {},
	accounts: {}
};
